






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class Button extends Vue {
  @Prop({
    type: String,
    default: 'normal',
    required: false
  })
  type!: string
  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  disabled!: boolean
  @Prop({
    type: String,
    default: '',
    required: false
  })
  size!: string
}
